import { FilterItem } from "../types";

export const getTotalFromRelatedFeatures = (data: FilterItem[]): number | string => {
  return data?.reduce((result, { value }) => result + Number(value), 0)?.toFixed(0) || "";
};
